// extracted by mini-css-extract-plugin
module.exports = {"root":"tableWrapper_root__3MQfv","pagination":"tableWrapper_pagination__2jVk_"};